module.exports = __webpack_public_path__ + "img/四川天府新区煎茶小学.cdaea556.jpg";